import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileDown, RefreshCw, Undo2 } from "lucide-react";
import { openAuthedFile, labelFilename } from "@/lib/openFile";
import { LabelFormatDialog } from "@/components/LabelFormatDialog";
import { labelFormatName } from "@/lib/labelFormat";

const other = (f) => (f === "a4" ? "labeldrucker" : "a4");
const err = (e) => e?.response?.data?.detail || e?.message || "Fehlgeschlagen.";

// Label öffnen + „Label im anderen Format neu abrufen“ (Label und – falls vorhanden – Retour-Label)
export const ShipmentLabelActions = ({ s, auftragsnummer, onChanged, size = "sm" }) => {
  const [refetch, setRefetch] = useState(null); // null | "label" | "retour"
  const retoure = refetch === "retour";
  const current = retoure ? s.retour_label_format : s.label_format;

  const doRefetch = async (format) => {
    try {
      await api.post(`/versand/${s.id}/label/neu-abrufen`, { label_format: format, retoure });
      toast.success(`${retoure ? "Retour-Label" : "Label"} im Format „${labelFormatName(format)}“ neu abgerufen.`);
      onChanged?.();
    } catch (e) { toast.error(err(e)); throw e; }
  };
  const open = (url, retour) => openAuthedFile(url, labelFilename({ ...s, auftragsnummer: s.auftragsnummer || auftragsnummer }, retour))
    .catch((e) => toast.error(`${retour ? "Retour-Label" : "Label"} konnte nicht geöffnet werden: ${e.message}`));

  if (!s.label_url) return null;
  return (
    <>
      <Button size={size} variant="outline" onClick={() => open(s.label_url, false)} title={s.label_format ? `Format: ${labelFormatName(s.label_format)}` : undefined} data-testid={`shipment-label-${s.id}`}>
        <FileDown className="w-4 h-4 mr-1" /> Label
      </Button>
      <Button size={size} variant="ghost" onClick={() => setRefetch("label")} title="Label im anderen Format neu abrufen" aria-label="Label im anderen Format neu abrufen" data-testid={`shipment-label-refetch-${s.id}`}>
        <RefreshCw className="w-4 h-4" />
      </Button>
      {s.retour_label_url && (
        <Button size={size} variant="ghost" onClick={() => setRefetch("retour")} title="Retour-Label im anderen Format neu abrufen" aria-label="Retour-Label im anderen Format neu abrufen" data-testid={`shipment-retour-refetch-${s.id}`}>
          <Undo2 className="w-4 h-4 mr-0.5" /><RefreshCw className="w-3 h-3" />
        </Button>
      )}
      <LabelFormatDialog open={!!refetch} onOpenChange={(o) => !o && setRefetch(null)} testId="label-refetch-dialog"
        title={retoure ? "Retour-Label im anderen Format neu abrufen" : "Label im anderen Format neu abrufen"}
        description={`Aktuell: ${labelFormatName(current) || "Standard aus dem DHL-Konto"}. Es wird keine neue Sendung angelegt. DHL liefert Labels nur bis zum Tagesabschluss der Sendung.`}
        confirmLabel="Neu abrufen" defaultFormat={other(current)} onConfirm={doRefetch} />
    </>
  );
};
